module.exports = __webpack_public_path__ + "img/hion-footer-logo.919734b4.png";